import { Tabs, Typography } from "antd"
import Main from "modules/layout/dashboard/main"
import { useEventId, usePresenceId } from "pages/events"
import { useTranslation } from "react-i18next"
import { useEventMember, useExecutionMember } from "../queries"
// import PersonalInfo from "./personal-info"
// import Respondents from "./respondents"
import Diagnostic from "./diagnostic"
import { useEvent } from "pages/events/queries"
import { useMemo } from "react"
import RecommendedIntervention from "./recommended-intervention"
import MemberEvents from "./events"

const { Title } = Typography

const MemberDetail: React.FC = () => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const presenceId = usePresenceId() // or memberId
  const event = useEvent(eventId!)
  const executionMember = useExecutionMember(eventId!, presenceId!, {
    enabled: event.data?.status === "execution",
  })
  const eventMember = useEventMember(eventId!, presenceId!, {
    enabled: event.data?.status === "approved",
  })
  const member = useMemo(
    () =>
      event.data?.status === "execution"
        ? { ...executionMember, data: executionMember.data?.member }
        : eventMember,
    [eventMember, executionMember, event.data?.status]
  )

  return (
    <>
      <Main.PageHeader
        title={<Title level={3}>{(member.data as any)?.name}</Title>}
      />
      <Tabs
        style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
        items={[
          {
            key: "recommended_intervention",
            children: <RecommendedIntervention member={member as any} />,
            label: t("members.recommended_intervention"),
          },
          {
            key: "diagnostic",
            children: <Diagnostic event={event} />,
            label: t("members.diagnostic"),
          },
          // {
          //   key: "respondents",
          //   children: <Respondents member={member as any} />,
          //   label: t("members.respondents"),
          // },
          // {
          //   key: "personal_info",
          //   children: <PersonalInfo member={member as any} />,
          //   label: t("members.personal_info"),
          // },
          {
            key: "events",
            children: <MemberEvents />,
            label: t("members.events"),
          },
        ]}
      />
    </>
  )
}

export default MemberDetail
